document.addEventListener('DOMContentLoaded', function () {

  /* Scroll-triggered reveal animations */
  var revealEls = document.querySelectorAll('[data-reveal]');
  if (revealEls.length) {
    if ('IntersectionObserver' in window) {
      var revealObserver = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
      revealEls.forEach(function (el) { revealObserver.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('is-visible'); });
    }
  }

  /* Page progress bar (top loading bar on navigation) */
  var progressBar = document.querySelector('[data-page-progress]');
  function progressStart() {
    if (!progressBar) return;
    progressBar.style.transition = 'none';
    progressBar.style.transform = 'scaleX(0)';
    progressBar.classList.add('is-active');
    // force reflow so the next transform change animates
    progressBar.offsetHeight;
    progressBar.style.transition = '';
    requestAnimationFrame(function () {
      progressBar.style.transform = 'scaleX(0.55)';
    });
  }
  function progressFinish() {
    if (!progressBar) return;
    progressBar.style.transform = 'scaleX(1)';
    setTimeout(function () {
      progressBar.classList.remove('is-active');
      setTimeout(function () { progressBar.style.transform = 'scaleX(0)'; }, 240);
    }, 220);
  }
  progressFinish();
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) progressFinish();
  });

  /* Sidebar drawer (collections nav) */
  var sidebarToggle = document.querySelector('[data-sidebar-toggle]');
  var sidebarClose = document.querySelector('[data-sidebar-close]');
  var sidebar = document.querySelector('[data-sidebar]');
  var overlay = document.querySelector('[data-sidebar-overlay]');

  function openSidebar() {
    if (!sidebar) return;
    sidebar.classList.add('is-open');
    overlay.classList.add('is-open');
    sidebar.setAttribute('aria-hidden', 'false');
    sidebarToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeSidebar() {
    if (!sidebar) return;
    sidebar.classList.remove('is-open');
    overlay.classList.remove('is-open');
    sidebar.setAttribute('aria-hidden', 'true');
    sidebarToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
  if (sidebarToggle && sidebar && overlay) {
    sidebarToggle.addEventListener('click', openSidebar);
    sidebarClose.addEventListener('click', closeSidebar);
    overlay.addEventListener('click', closeSidebar);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSidebar();
    });
  }

  /* Quantity steppers */
  document.querySelectorAll('[data-qty-row]').forEach(function (row) {
    var input = row.querySelector('input');
    row.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-step'), 10);
        var val = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = val;
        input.dispatchEvent(new Event('change'));
      });
    });
  });

  /* Product option swatches -> resolve selected values to a real variant id */
  var variantScript = document.querySelector('[data-product-variants]');
  var variants = variantScript ? JSON.parse(variantScript.textContent) : null;
  var optionGroups = document.querySelectorAll('[data-option-group]');

  function currentSelection() {
    var selection = [];
    optionGroups.forEach(function (group) {
      var pressed = group.querySelector('.swatch[aria-pressed="true"]');
      var position = parseInt(group.querySelector('.swatch').getAttribute('data-option-position'), 10);
      selection[position - 1] = pressed ? pressed.getAttribute('data-value') : null;
    });
    return selection;
  }

  function updateFromSelection() {
    if (!variants) return;
    var selection = currentSelection();
    var match = variants.find(function (v) {
      var opts = [v.option1, v.option2, v.option3];
      return selection.every(function (val, i) { return val === null || val === opts[i]; });
    });
    if (!match) return;

    var idInput = document.querySelector('[data-variant-id-input]');
    if (idInput) idInput.value = match.id;

    var priceEl = document.querySelector('[data-product-price]');
    if (priceEl && match.price != null) {
      priceEl.textContent = (match.price / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR', minimumFractionDigits: 0 });
    }

    var submitBtn = document.querySelector('[data-add-to-cart] [type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = !match.available;
      submitBtn.textContent = match.available ? 'Add to cart' : 'Sold out';
    }
  }

  optionGroups.forEach(function (group) {
    var buttons = group.querySelectorAll('.swatch');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        updateFromSelection();
      });
    });
  });

  /* AJAX add to cart */
  document.querySelectorAll('[data-add-to-cart]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = form.querySelector('[type="submit"]');
      var originalText = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding…';
        submitBtn.classList.add('is-adding');
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(Object.fromEntries(new FormData(form)))
      })
        .then(function (res) { return res.json(); })
        .then(function () { return fetch('/cart.js'); })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var countEls = document.querySelectorAll('[data-cart-count]');
          countEls.forEach(function (el) {
            el.textContent = cart.item_count;
            el.hidden = cart.item_count === 0;
            el.classList.remove('is-bumping');
            // restart the bump animation
            void el.offsetWidth;
            el.classList.add('is-bumping');
          });
          if (submitBtn) {
            submitBtn.classList.remove('is-adding');
            submitBtn.classList.add('is-added');
            submitBtn.textContent = 'Added';
          }
          setTimeout(function () {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.classList.remove('is-added');
              submitBtn.textContent = originalText;
            }
          }, 1400);
        })
        .catch(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.classList.remove('is-adding');
            submitBtn.textContent = originalText;
          }
        });
    });
  });

  /* Cart quantity change -> update line item via AJAX on cart page */
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var key = input.getAttribute('data-key');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: parseInt(input.value, 10) || 1 })
      }).then(function () { window.location.reload(); });
    });
  });

  document.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.getAttribute('data-key');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function () { window.location.reload(); });
    });
  });

  /* Page transitions: fade/slide #MainContent on internal navigation */
  var mainContent = document.getElementById('MainContent');
  if (mainContent) {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        mainContent.classList.remove('is-loading');
      });
    });

    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href]');
      if (!link) return;
      if (link.target && link.target !== '_self') return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      if (link.hasAttribute('download')) return;

      var url;
      try { url = new URL(link.href, window.location.href); } catch (err) { return; }
      if (url.origin !== window.location.origin) return;
      if (url.pathname === window.location.pathname && url.hash) return; // in-page anchor

      e.preventDefault();
      mainContent.classList.add('is-leaving');
      progressStart();
      setTimeout(function () {
        window.location.href = link.href;
      }, 260);
    });

    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        mainContent.classList.remove('is-leaving');
        mainContent.classList.remove('is-loading');
      }
    });
  }

  /* Collection sort */
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }
});
